import { render, staticRenderFns } from "./IntermediaryImage.vue?vue&type=template&id=f870a206&"
import script from "./IntermediaryImage.vue?vue&type=script&lang=js&"
export * from "./IntermediaryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports